module.exports = __webpack_public_path__ + "1e97e8d76fe2d553eedddc23f833bfe5.svg";